/** Mirrors `movies-translation-server/utils/subscriptionVolumeLimits.js` and admin `subscriptionVolumeLimits.ts` — keep in sync. */
export type SubscriptionPackVolumes = {
  speechToTextVolume: number;
  textToSpeechVolume: number;
  textTranslationVolume: number;
};

export function getVolumeLimitsForSubscription(
  subscriptionType: string
): SubscriptionPackVolumes {
  switch (subscriptionType) {
    case "FREE":
      return {
        speechToTextVolume: 0,
        textToSpeechVolume: 0,
        textTranslationVolume: 0,
      };
    case "STARTER":
      return {
        speechToTextVolume: 60,
        textToSpeechVolume: 48000,
        textTranslationVolume: 48000,
      };
    case "PRO":
      return {
        speechToTextVolume: 150,
        textToSpeechVolume: 120000,
        textTranslationVolume: 120000,
      };
    case "PREMIUM":
      return {
        speechToTextVolume: 400,
        textToSpeechVolume: 320000,
        textTranslationVolume: 320000,
      };
    default:
      return {
        speechToTextVolume: 0,
        textToSpeechVolume: 0,
        textTranslationVolume: 0,
      };
  }
}
